import React, {useCallback, useEffect, useState} from 'react';
import useSWRImmutable from "swr/immutable";
import {FiInstagram} from "react-icons/fi";
import useSWR from "swr";


const toArray = (reqs) => {
    if(reqs){
        const arr:Array<{
            value: string,
            message: string,
            type:'number'
            key:'followers_count' | 'media_count'
        }> = [];
        if(reqs.min_length){
            arr.push({type:"number", key:'followers_count', value:reqs.min_followers, message:reqs.min_followers_message})
        }
        if(reqs.min_numbers){
            arr.push({type:"number", key:'media_count', value:reqs.min_posts, message:reqs.min_posts_message})
        }
        return arr;
    }

}

const fetcher = (url) => fetch(url).then(res => res.json())
let domain = window.location.protocol + '//' + window.location.host;
let opener: Window | null = null;
function InstagramInput({value, onChange, requirements}) {
    const {data} = useSWRImmutable('https://ig.goaffpro.app/instagram/public/connect_url?return_url='+domain+'/__data', fetcher);
    const [error, setError] = useState<Array<string | null>>([]);
    const [profiles, setProfiles] = useState(null)
    const {data: profileData} = useSWR(value ?
        `https://api-server-3.goaffpro.com/extras/instagram_profile/${value.substring(3)}`
        :null, fetcher
    )
    const profileList =  profileData?.data || profiles
    const onClick = ()=>{
        opener = window.open(data.url, '_blank', 'width=500,height=600');
    }
    const eventProcessor = useCallback((event) => {
        try {
            const url = event.data;
            if(!url.startsWith('http')){
                return;
            }
            const key = new URL(url).searchParams.get('ig')
            fetcher(`https://api-server-3.goaffpro.com/extras/instagram_profile/${key}`)
                .then((profile)=>profile.data)
                .then((x)=>{
                    if(x){
                        const ar = toArray(requirements)
                        const areAlLValid = ar ? ar.every(req => {
                            const val = x.reduce((acc, cur)=>acc + Number(cur[req.key]), 0)
                            return val >= Number(req.value);
                        }) : true;

                        if(areAlLValid) {
                            setProfiles(x)
                            onChange({
                                target: {
                                    value: `ig|${key}`
                                }
                            })
                        }else if(ar){
                            setError(ar.map(req => {
                                const val = x.reduce((acc, cur)=>acc + Number(cur[req.key]), 0)
                                if(val < Number(req.value)){
                                    return req.message || `Instagram account should have at least ${req.value} ${req.key.replace('_', ' ')}`
                                }
                                return null;
                            }))
                        }
                    }
                })

            if (!opener?.closed) {
                opener?.close()
            }
        }catch(e){

        }
    },[])
    useEffect(() => {
        window.addEventListener("message",eventProcessor);
        return ()=>{
            window.removeEventListener("message", eventProcessor);
        }
    },[eventProcessor])

    return (<>
        <div className="d-flex flex-wrap gap-2">
            {
                profileList?.map((profileData:any) => {
                    return (
                        <div key={profileData.username}
                             className={"border rounded-pill d-inline-flex px-2 py-1 align-items-center gap-2"}>
                            <img src={profileData.profile_picture_url} alt={profileData.username} style={{width:40, height:40, borderRadius:'50%'}}/>
                            <span>{profileData.username}</span>
                        </div>
                    )
                })
            }
        </div>
            {
                !value ?
                    <button type={"button"}
                            className={"btn btn-light border"}
                            onClick={onClick}><FiInstagram/> Connect Instagram</button> : null
            }
    </> );
}

export default InstagramInput;
